import React, { useState, useEffect } from 'react';
import { fifoService } from '../../services/fifoService';
import { toast } from 'react-toastify';
import PageLoader from '../../components/PageLoader';

const InventoryQueue = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchRequests = async () => {
        setLoading(true);
        try {
            const data = await fifoService.getPendingRequests();
            setRequests(data);
        } catch (error) {
            toast.error('ไม่สามารถโหลดข้อมูลรายการได้');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRequests();
    }, []);

    const handleAction = async (docId, serial, action, currentStatus) => {
        try {
            if (action === 'accept') {
                // Send to QC
                await fifoService.acceptSerial(serial);
                toast.success(`ส่งรายการ ${serial} ไป QC แล้ว`);
            } else if (action === 'reject') {
                if (!window.confirm('ยืนยันลบรายการนี้? สถานะสินค้าจะกลับเป็น "ว่าง"')) return;
                await fifoService.updateStatus(docId, 'Available');
                toast.info(`ลบรายการ ${docId} แล้ว`);
            }
            fetchRequests(); // Refresh
        } catch (error) {
            toast.error('เกิดข้อผิดพลาดในการดำเนินการ');
            console.error(error);
        }
    };

    return (
        <div>
            <h2 className="mb-4 theme-page-title"><i className="bi bi-box-seam me-2"></i>รายการเบิกสินค้า (Queue)</h2>

            {loading ? <PageLoader message="กำลังโหลดข้อมูล..." /> : (
                <div className="theme-card">
                    <div className="theme-card-body">
                        {requests.length === 0 ? (
                            <div className="text-center py-5 text-muted">
                                <i className="bi bi-inbox display-4 mb-3 d-block opacity-50"></i>
                                ไม่มีรายการรอเบิกขณะนี้
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table theme-table table-hover">
                                    <thead>
                                        <tr>
                                            <th>วันที่</th>
                                            <th>เลขที่เอกสาร</th>
                                            <th>ลูกค้า</th>
                                            <th>สินค้า</th>
                                            <th>S/N</th>
                                            <th>ผู้เบิก</th>
                                            <th>สถานะ</th>
                                            <th>ดำเนินการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {requests.map((req) => (
                                            <tr key={req.id}>
                                                <td>{new Date(req.created_at).toLocaleDateString('th-TH')}</td>
                                                <td>{req.document_id}</td>
                                                <td>{req.customer_name}</td>
                                                <td>
                                                    <div className="text-truncate" style={{ maxWidth: '200px' }}>{req.description}</div>
                                                    <small className="text-muted">{req.product_id}</small>
                                                </td>
                                                <td className="fw-bold">{req.sn_number}</td>
                                                <td>{req.name}</td>
                                                <td>
                                                    <span className="badge bg-warning text-dark">
                                                        {req.status === 'Pending' ? 'รอเบิก' : req.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="btn-group">
                                                        <button
                                                            className="btn btn-sm btn-success"
                                                            onClick={() => handleAction(req.document_id, req.sn_number, 'accept')}
                                                            title="Process (ส่ง QC)"
                                                        >
                                                            <i className="bi bi-check-circle me-1"></i> เบิก/ส่ง QC
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => handleAction(req.document_id, req.sn_number, 'reject')}
                                                            title="Reject/Cancel"
                                                        >
                                                            <i className="bi bi-x-lg"></i> ยกเลิก
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default InventoryQueue;
